<template>
  <div
    class="bg-center bg-no-repeat bg-cover items-center"
    :style="{
      backgroundImage: 'url(' + $store.state.settings.background + ')',
    }"
  >
    <div class="container mx-auto">
      <div class="h-full min-h-screen flex">
        <div class="m-auto w-full">
          <div class="flex justify-center">
            <div class="w-full rounded-md shadow max-w-md bg-white p-5">
              <div class="justify-center mb-8 md:flex items-center">
                <img :src="$store.state.settings.icon" :alt="$store.state.settings.app_name" class="w-20 h-20 rounded-md" />
              </div>
              <loading class="rounded-md" :status="loading"></loading>
              <template v-if="isActive">
                <p class="text-gray-700">
                  {{ $t('You are just logged in successfully please go to home') }}
                </p>
                <br /><br />
                <router-link to="/" class="btn btn-app mt-2">{{ $t('Home') }}</router-link>
              </template>
              <template v-else>
                <router-view />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'auth',
  metaInfo() {
    return {
      titleTemplate: `%s - ${this.$store.state.settings.name}`,
    };
  },
  data() {
    return {
      isActive: false,
      loading: false,
    };
  },
  watch: {
    activeUser(user) {
      this.loading = true;
      setTimeout(() => {
        this.isActive = user.id > 0;
        this.loading = false;
      }, 1500);
    },
  },
  computed: {
    activeUser() {
      return this.$store.state.user;
    },
  },
};
</script>
